import App from "../../../vendor_core/core/src/App";
import { Timeline } from "../../../vendor_core/core/src/Timeline";
import { Tween } from "../../../vendor_core/core/src/Tween";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import {
    ISpinificationData,
    ISymbolPosition,
    IWinData,
    OverlayType,
} from "../../../vendor_core/core/src/server/data/ISpinData";
import Layout from '../../../vendor_core/core/src/utils/Layout';
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import VendorReelGroup from "../../../vendor_core/src/view/VendorReelGroup";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import ReelSymbol from "../../../vendor_core/core/src/views/Symbol";
import { AnimatedSprite, Graphics, Point, Rectangle } from "pixi.js";
import Utils from "../../../vendor_core/core/src/utils/Utils";
import { ReelOrientation } from "../../../vendor_core/core/src/views/Reel";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import { BonusPositionTypes } from "../../../vendor_core/core/src/server/data/BonusPositionTypes";
import MYSymbolAnimation from "../view/MYSymbolAnimation";
import BitmapTextField from "../../../vendor_core/core/src/views/components/BitmapTextField";
import { FadeOut } from "../../../vendor_core/core/src/transitions/TransitionAnimations";
import PromiseHelpers from "../../../vendor_core/core/src/utils/PromiseHelpers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import { Ease } from "../../../vendor_core/core/src/Ease";
import ConsoleUtil from "../../../vendor_core/core/src/utils/ConsoleUtil";
import * as Easings from "../../../vendor_core/core/src/utils/Easings";
import GameSoundVars from "../enums/GameSoundVars";
import BuyFeatureModel from '../../../vendor_core/core/src/model/BuyFeatureModel';
import Configs from '../../../vendor_core/src/vendorConfigs/Configs';

class VOEReelGroup extends VendorReelGroup {
    public wildSymbolAnim: AnimatedSprite;
    protected isSpinifySymLanded: boolean = false;
    protected scatterCounter: number = 0;
    protected spellsCounter: number = 0;

    /**
     * Keeps animation settings, regarding the blackhole and growing multipliers.
     *
     * @public
     * @memberof VOEReelGroup
     */
    public get mulipliersConf() {
        return {
            /** Defines the initial scale of the black hole multiplier, measured in relative percents.
             *
             * 0.1 means 10%, 1.0 means 100%, etc.
            */
            scaleStartValue: 0,

            /** Defines the final scale for a black hole multiplier , measured in relative percents */
            scaleEndValue: 1.5,

            /** Defines bounce zoom of a growing multipler target, measured in relative percents */
            scaleEndValueBN2: 0.5,

            /** Defines how much seconds the multiplier scale up will take. */
            scaleTime: 0.3,

            /** Must be greater than bh_shiftTime */
            delayBetweenBlackHoles: 0.45,

            delayBetweenFlames: 0.03,

            /** Defines how much seconds the black hole multiplier movement will take. */
            bh_shiftTime: 0.40,

            /** Defines how much time to wait, before starting the 2nd shift */
            bh_delayBetweenShifts: 0.10,

            /** Defines how much seconds the growing multipliers movement will take. */
            gr_shiftTime: 1.2,

            // CircOut - is good too
            bh_shiftEase: Ease.Slow,

            gr_shiftEase: Ease.ExpoInOut,

            /** Defines the min opacity [range 0.0 - 1.0], when two multipliers merge or growing multiplier flies. */
            minOpacity: 0.35,

            /** Defines the final color of a merged black hole multiplier */
            endColor: 0x00ffff,

            /** Defines the time needed to fade out the black hole multipliers on next spin. */
            fadeOutTime: 0.25,

            /** Defines whether to draw visual debug items on the screen or not. */
            debugDraw: false,

            /** Defines a name for the debug drawn objects. */
            debugName: "BLACK_HOLE_DEBUG_DRAW"
        }
    }

    constructor() {
        super();
        this.waysLinesAboveSymbols = true;
    }

    public create(
        scene: SceneView,
        symbolData?: any[][],
        groupConfig?: {
            winLineLayer?: string;
            celеbrationLayer?: string;
            winSymbolsLayer?: string;
            reelExtraSymbols?: number;
        },
        forceLandscapeConfig: boolean = true,
        automaskReels: boolean = true,
        forcedReelOrientation: ReelOrientation = undefined
    ) {
        super.create(scene, symbolData, groupConfig, forceLandscapeConfig, automaskReels, forcedReelOrientation);

        this.scene = scene;
        const reelGroup = this.scene.getSubView("ReelGroup") as VOEReelGroup;
        this.spinners.forEach(spinner => {
            spinner.setCustomHit((symId: number, reelId: number, rowId: number) => {
                const finalSymId = SpinModel.reelStopSymbols[reelId][rowId - reelGroup.reels[reelId].getExtraSymbolsCount()];

                if (GameModel.gameConfig.spinifySymIds.indexOf(symId) != -1)
                {
                    this.isSpinifySymLanded = true;

                    // if(SpinModel.hasFreespinsWon()) {
                        const symSpine = reelGroup.getSymbolAt(reelId, rowId - this.groupConfig.reelExtraSymbols);
                        symSpine.playAnimation("landing");
                        const scatterType = symId - 12;
                        SoundController.playSound(`scatter_appear_${scatterType}_${this.scatterCounter}`);
                        this.scatterCounter++;
                        if (this.scatterCounter == 3) {
                            SoundController.playSound(GameSoundVars.SCATTER_UNLOCK);
                        }
                    // }
                }
                if (symId == 14) {  // black hole symbol
                    // const bhAnim = reelGroup.getSymbolAt(reelId, rowId - this.groupConfig.reelExtraSymbols);
                    SoundController.playSound(`black_spell_${this.spellsCounter}`);
                    this.spellsCounter++;
                    // bhAnim.playAnimation("landing").then(() => {
                    //     let playBurnAnim: boolean = true;
                    //     SpinModel.overlays.forEach((overlay) => {
                    //         if (overlay.type == OverlayType.Expanding) {
                    //             overlay.initPositions.forEach((obj) => {
                    //                 if (obj.reel == reelId && obj.row == rowId - this.groupConfig.reelExtraSymbols) {
                    //                     playBurnAnim = false;
                    //                 }
                    //             });
                    //         }
                    //     });
                    //     // if (playBurnAnim) {
                    //     //     bhAnim.playAnimation("black_hole_start")
                    //     //         .then(() => bhAnim.playAnimation("black_hole_loop"));
                    //     // }
                    // });

                }
            })
        })
    }

    public stop(
        stopData: any[][],
        delay = 0,
        spinificationData?: ISpinificationData
    ) {
        this.scatterCounter = 0;
        this.spellsCounter = 0;
        this.spinners.forEach((spinner, reelIdx) => {
            let sndNames = [];
            if (GameModel.turboSpin) {
                sndNames.push(SoundVars.EFFECT_REEL_QUICK_STOP);
            } else {
                sndNames.push(SoundVars.EFFECT_REEL_STOP);
            }

            spinner.setSounds({
                stop: sndNames,
            });
        });

        super.stop(stopData, delay, spinificationData);
    }

    protected stopReels(delay?: number): void {
        if (!this.stoppingStarted) {
            if (!this.spinTime) {
                // Probably some generic error occured - reelgroup can not stop,
                // because it has not been started yet.
                return;
            }

            this.stoppingStarted = true;
            this.spinDelayedCalls.forEach((delayedCall) => delayedCall.kill());
            this.reelStopping = 0;
            // let delay = 0;
            let spinificationData =
                this.spinificationData || SpinModel.spinification;

                let delaySpinRatio: number[];
                if(Configs?.reels?.individualReelSpinDelay) {
                    delaySpinRatio = this.getDelaySpinRatio();
                }
            for (let reelIdx = 0; reelIdx < this.reels.length; reelIdx++) {
                const r = this.reels[reelIdx];
                const s = this.spinners[reelIdx];

                if (!r.isHeld) {
                    // In case stop starts before the delayed spin
                    s.spin();
                }

                r.once(
                    GameEvents.REEL_STOPPED,
                    () => this.onReelStopped(reelIdx, spinificationData),
                    this
                );
                if (SpinModel.stopImmediately) {
                    delay += App.config.instantStopDelayTime;
                } else if (GameModel.turboSpin) {
                    delay += App.config.quickStopDelayTime;
                } else if (
                    (!BuyFeatureModel.isInBuyFeatureFreeSpins ||
                       (GameModel.gameConfig.buyFSAnticipationDisable == undefined ||
                        GameModel.gameConfig.buyFSAnticipationDisable == false)
                    ) &&
                    spinificationData &&
                    spinificationData.spinificationIndex <= reelIdx &&
                    spinificationData.spinificationEndIndex > 0 &&
                    spinificationData.spinificationIndex <=
                    spinificationData.spinificationEndIndex &&
                    (spinificationData.spinificationEndIndex >= reelIdx ||
                        this.hasAnticipation)
                ) {
                    this.hasAnticipation = true;
                    // let spinificationStartIndex = spinificationData.spinificationIndices? spinificationData.spinificationIndices[reelIdx] : reelIdx;
                    if (
                        reelIdx === 0 &&
                        spinificationData.spinificationEndIndex > reelIdx
                    ) {
                        // s.activateAnticipation();
                        // this.anticipation.play(reelIdx);
                        this.startAnticipation(reelIdx, spinificationData);
                    }
                    // s.activateAnticipation();
                    // delay += (spinificationStartIndex + 1) * App.config.reelSpinificationDuration;
                } else if (!r.isHeld) {
                    // If response time is bigger then min spin time !
                    delay += this.config.reelStopDelayTime;
                }

                if (!this.hasAnticipation) {
                    this.stopDelayedCalls.push(
                        this.addDelayedCall(
                            delay,
                            s.stop,
                            [this.resultData[reelIdx]],
                            s
                        )
                    );
                }

                // this.stopDelayedCalls.push(this.addDelayedCall(delay , s.stop, [SpinModel.getStopSymsForReel(reelIdx)], s));
            }
        }
    }

    public hasBlackHole(): boolean {
        let result = false;

        for (let ri = 0; ri < this.reels.length; ri++) {
            const r = this.reels[ri];
            let brk = false;
            for (let ci = 0; ci < r.symbols.length; ci++) {
                const sym = r.symbols[ci];
                if (sym.id === 14) {
                    result = true;
                    brk = true;
                    break;
                }

            }

            if (brk) {
                break;
            }

        }

        return result
    }

    public showSummaryWinLines(winlinesToShow: IWinData[], playWinSound: boolean = true) {
        super.showSummaryWinLines(winlinesToShow, false);
        this.darkedLockedOverlay(winlinesToShow);

        if(App.config.highliteWinSymbolsOnly) {
            this.darkedSymbols([14])
            this.hightLightWinDarkedSymbols(winlinesToShow);
        }
    }

    public darkedSymbols(exclude: number[] = []): void {
        this.reels.forEach((reel) => {
            reel.symbols.forEach((symbol) => {
                if (!exclude.includes(symbol.id)) {
                    symbol.playAnimation("darken");
                }

                if (symbol.id === 14) {
                    symbol.playAnimation("black_hole_loop");
                }
            })
        });
    }

    private hightLightWinDarkedSymbols(winlinesToShow: IWinData[]): void {
        winlinesToShow.forEach(w => {
            w.coordinates.forEach(c => {
                const sym = this.getSymbolAt(c.x, c.y);
                if (sym) {
                    if (sym.id === 14) {
                        sym.playAnimation("black_hole_loop");
                    } else {
                        sym.playAnimation("idle");
                    }
                }
            })
        })
    }

    private darkedLockedOverlay(winlinesToShow: IWinData[]) {
        const tempDarkenSymbols: {key: string, anim: MYSymbolAnimation}[] = [];
        if (SpinModel.isInFreespins()) {
            const overlay = SpinModel.getOverlay(OverlayType.Locked);
            overlay?.symbolPosition?.forEach((r, ri) => {
                r.forEach((c, ci) => {
                    if (c) {
                        const anim = this.winSymbolsView.getAnimAtReelCell(ri, ci) as MYSymbolAnimation;
                        tempDarkenSymbols.push({
                            key:`${ri}x${ci}`,
                            anim: anim
                        });
                    }
                })
            })

            winlinesToShow.forEach(win => {
                win.coordinates.forEach(c => {
                    const indexForSplice = tempDarkenSymbols.findIndex(o => o.key === `${c.x}x${c.y}`);
                    if (indexForSplice > -1) {
                        tempDarkenSymbols.splice(indexForSplice, 1)
                    }
                })
            })

            tempDarkenSymbols.forEach(s => {
                s.anim.showAnim(1, "dark")
            })
        }
    }

    public stopImmediately(stopData: any[][]) {

        this.spinners.forEach(spinner => {
            spinner.setSounds({
                stop: SoundVars.EFFECT_REEL_QUICK_STOP
            })
        });

        super.stopImmediately(stopData);
    }

    public onReelStopped(reelIdx: number, spinificationData: ISpinificationData): void {
        super.onReelStopped(reelIdx, spinificationData);
        this.startBlackFire(reelIdx);
        this.showBlackHoleMultipliers(reelIdx);
    }

    private startBlackFire(reelIdx: number) {
        this.reels[reelIdx].symbols.forEach(s => {
            if (s.id === 14) {
                s.playAnimation("expanding_chain");
            }
        })
    }

    public spin(delay: number = 0, easeFunc?: (number) => number) {
        this.spinTime = new Date().getTime();
        ConsoleUtil.green("[ReelGroup] START DURATION: ");

        delay = delay || App.config?.individualReelSpinDelayConf?.startReelsDelay;
        easeFunc = Easings.OutBack;

        if (this.winLineTimeline) {
            this.winLineTimeline.kill();
        }
        this.hasAnticipation = false;
        this.anticipationStarted = false;
        this.spinificationData = null;
        this.reelStopping = 0;
        if (GameModel.turboSpin) {
            delay = 0;
        }
        SoundController.playSound(SoundVars.EFFECT_REEL_START);
        this.spinDelayedCalls = [];
        this.reelsSpinning = 0;
        let reelsToSpin = 0;
        for (let reelIdx = 0; reelIdx < this.spinners.length; reelIdx++) {
            const s = this.spinners[reelIdx];
            const r = this.reels[reelIdx];
            if (!r.isHeld) {
                let currentDelay = delay * reelsToSpin;
                reelsToSpin++;
                this.spinDelayedCalls.push(
                    this.addDelayedCall(
                        currentDelay,
                        () => {
                            this.reelsSpinning++;
                            s.spin(easeFunc);
                            if (
                                this.reelsSpinning >= this.spinners.length
                                ) {
                                this.emit(GameEvents.ALL_REELS_STARTED);
                            }
                            if (GameModel.turboSpin) {
                                s.activateTurbo();
                            }
                        },
                        [],
                        s
                    )
                );
            }
        }

        this.isMinSpinTimeComplete = false;
        this.stoppingStarted = false;
        this.stopSymbolsAvailable = false;
        this.stopDelayedCalls = [];
        SpinModel.stopImmediately = false;

        ConsoleUtil.yellow("MIN TIME: " + this.config.minSpinTime);
        ConsoleUtil.yellow("DELAY: " + delay);

        let startToStopReels = delay * this.spinners.length;

        if (GameModel.turboSpin) {
            startToStopReels = Math.max(
                delay * reelsToSpin,
                this.config.quickSpinTime
            );
        }

        this.addDelayedCall(startToStopReels, this.allowStop, [], this);

        if (this.trailPool) {
            this.trailPool.destroyAll();
        }

        this.clearBlackHoleMultipliers();
        this.showGrowingMultipliers();
    }

    private clearDebugDrawBHRects() {
        this.winSymbolsView.children.filter(ch => ch.name == this.mulipliersConf.debugName).forEach(ch => {
            this.winSymbolsView.removeChild(ch);
        })
    }

    public stopSymbolAnimations() {
        this.off(GameEvents.GROUP_ANIM_COMPLETE);
        for (let i = 0; i < this.reels.length; i++) {
            const reel = this.reels[i];
            const numSyms = reel.symbols.length;
            for (let symIdx = 0; symIdx < numSyms; symIdx++) {
                const sym = reel.symbols[symIdx];
                if (sym.id !== 14) {
                    sym.stopAnimation();
                }
            }
        }
        this.winSymbolsView.stopAll();
    }

    private showBlackHoleMultipliers(reelIdx: number) {
        SpinModel.bonuses?.forEach(bonus => {
            if (bonus.type == BonusPositionTypes.SymbolMultiplier) {
                const reel = bonus.symbolPositions[0].reel;
                const row = bonus.symbolPositions[0].row;
                if (reelIdx == reel) {
                    // const reelSymAnim = this.getSymbolAt(reel, row);
                    const anim = this.winSymbolsView.getAnimAtReelCell(reel, row) as MYSymbolAnimation;
                    anim.zOrder = 1;
                    // set two diferent bmp fonts on BH symbol
                    // one for before merge and one for after merge
                    if (App.config.MinBHMultiplierGoldFont && 
                        App.config.MinBHMultiplierGoldFont > bonus.multiplier) {
                        anim.showTextOverlay(bonus.symbolId, `x${bonus.multiplier}`, "BN1FontPurple");
                    } else {
                        anim.showTextOverlay(bonus.symbolId, `x${bonus.multiplier}`, "BN1FontGold"); 
                    }
                    anim.showTextOverlay(bonus.symbolId, `x${bonus.multiplier}`, "BN1FontRed");
                    const text = anim.getTextOverlay(0) as BitmapTextField;
                    const text2 = anim.getTextOverlay(1) as BitmapTextField;
                    text2.alpha = 0;
                    const originalScale = new Point(text.scale.x, text.scale.y);
                    // reelSymAnim.playAnimation("expanding_chain");
                    // reelSymAnim.playAnimation("black_hole_start").then(() => reelSymAnim.playAnimation("black_hole_loop"));

                    Tween.fromTo(
                        text.scale,
                        this.mulipliersConf.scaleTime,
                        {
                            x: text.scale.x * this.mulipliersConf.scaleStartValue,
                            y: text.scale.y * this.mulipliersConf.scaleStartValue
                        },
                        {
                            x: text.scale.x * this.mulipliersConf.scaleEndValue,
                            y: text.scale.y * this.mulipliersConf.scaleEndValue
                        }
                    );

                    Tween.to(
                        text.scale,
                        this.mulipliersConf.scaleTime,
                        {
                            x: originalScale.x,
                            y: originalScale.y,
                            delay: this.mulipliersConf.scaleTime
                        }
                    );
                }
            }
        });
    }

    private clearBlackHoleMultipliers() {
        SpinModel.bonuses?.forEach(bonus => {
            if (bonus.type == BonusPositionTypes.SymbolMultiplier) {
                const anim = this.winSymbolsView.getAnimAtReelCell(bonus.symbolPositions[0].reel, bonus.symbolPositions[0].row) as MYSymbolAnimation;
                // check for two bitmap texts and fadeOut which is visible
                const text = anim.getTextOverlay(0);
                const text2 = anim.getTextOverlay(1);
                const promises = new Array<Promise<void>>();
                if (text && text.alpha > 0) {
                    promises.push(PromiseHelpers.tweenToPromise(FadeOut(text, this.mulipliersConf.fadeOutTime)))
                }
                if (text2 && text2.alpha > 0) {
                    promises.push(PromiseHelpers.tweenToPromise(FadeOut(text2, this.mulipliersConf.fadeOutTime)))
                }
                if (text || text2) {
                    PromiseHelpers.combineParallel(promises).then(() => {
                        anim.zOrder = 0;
                        anim.removeOverlay();
                    })
                } else {
                    anim.zOrder = 0;
                    anim.removeOverlay();
                }
            }
        });

        if (this.mulipliersConf.debugDraw) {
            this.clearDebugDrawBHRects();
        }
    }

    private showGrowingMultipliers() {
        if (SpinModel.featureMode != 2 || (!SpinModel.isInFreespins())) {
            return;
        }

        const multiEffect = ViewManager.getLayer("MultiEffects")
            .setScene("freespinsBN2").spineAnimations.get("multi_effects");
        const sceneMultiplier = ViewManager.getLayer("Multipliers").setScene("freespinsBN2");
        const counter = sceneMultiplier.sceneTextFields.get("multiplier_counter");

        if (SpinModel.freespinsNum == SpinModel.totalFreeSpins) {
            counter.text = "x1";
        } else if (SpinModel.winAmount > 0) {
            const counterBounds = counter.getLocalBounds();
            const counterCenter = new Point(
                counterBounds.x + counterBounds.width / 2,
                counterBounds.y + counterBounds.height / 2
            );

            const winsCont = ViewManager.getLayer(DefaultLayers.ReelsWin).getCurrentScene().containers.get("wins");
            winsCont.disableMask();

            const timeline = new Timeline({ onComplete: ()=> {
                winsCont.enableMask();
                counter.text = `x${SpinModel.winsMultiplier}`;
                let w = counter.element.width;
                let h = counter.element.height;
                Tween.to(
                    counter.element,
                    this.mulipliersConf.scaleTime,
                    {
                        width: w * this.mulipliersConf.scaleEndValueBN2,
                        height: w * this.mulipliersConf.scaleEndValueBN2,
                        onComplete: () => {
                            Tween.to(counter.element, this.mulipliersConf.scaleTime, { width: w, height: h });
                            multiEffect.playAsync("animation");
                            SoundController.playSound(GameSoundVars.BN2_MULTIPLIER_UP);
                        }
                    }
                )
            }});

            SpinModel.winsData.forEach(data => {
                data.coordinates.forEach(coord => {
                    const anim = this.winSymbolsView.getAnimAtReelCell(coord.x, coord.y) as MYSymbolAnimation;
                    const sym = this.getSymbolAt(coord.x, coord.y);
                    const text = anim.showTextOverlay(sym.id, "+1", "WinFont");
                    const endPos = text.toLocal(counter.toGlobal(counterCenter));
                    const deltaScale =  text.height / counter.height;
                    timeline.to(text.position, this.mulipliersConf.gr_shiftTime, { x: endPos.x, y: endPos.y, ease: this.mulipliersConf.gr_shiftEase }, 0);
                    timeline.to(text.scale, this.mulipliersConf.gr_shiftTime, { x: deltaScale, y: deltaScale }, 0);
                    timeline.to(text, this.mulipliersConf.gr_shiftTime, { alpha: this.mulipliersConf.minOpacity }, 0);
                    timeline.call(()=> {
                        anim.removeOverlay();
                    }, [], this, this.mulipliersConf.gr_shiftTime);
                })
            });
        }
    }

    showFinalSymbols(finalSyms: any[][]): void {
        if (SpinModel.bonuses?.find(x => x.type == BonusPositionTypes.ExpandingSymbol)) {
            this.sortSymbols();
            return;
        }

        super.showFinalSymbols(finalSyms);
    }

    public getWinAnimationName(symbol?: ReelSymbol): string {
        if (symbol?.id == 14) {
            return "black_hole_loop";
        }

        return super.getWinAnimationName(symbol);
    }
}

export default VOEReelGroup;
